import { loadRuntimeConfig } from './config/runtime';

async function start(): Promise<void> {
  // API clients and MSAL read configuration at module scope, so defer all app imports.
  if (process.env.NODE_ENV === 'production') await loadRuntimeConfig();
  await import('./bootstrap');
}

void start().catch(() => {
  const root = document.getElementById('root');
  if (root) {
    root.setAttribute('role', 'alert');
    root.textContent =
      'The application could not start. Please reload the page or contact support.';
  }
});
